__turbopack_context__.v({
  "fade-in": "ButtonCircle-module-scss-module__gpw-hW__fade-in",
  "icon": "ButtonCircle-module-scss-module__gpw-hW__icon",
  "icon-arrowLeft": "ButtonCircle-module-scss-module__gpw-hW__icon-arrowLeft",
  "icon-arrowRight": "ButtonCircle-module-scss-module__gpw-hW__icon-arrowRight",
  "icon-arrowRightRounded": "ButtonCircle-module-scss-module__gpw-hW__icon-arrowRightRounded",
  "icon-chevronDown": "ButtonCircle-module-scss-module__gpw-hW__icon-chevronDown",
  "icon-chevronLeft": "ButtonCircle-module-scss-module__gpw-hW__icon-chevronLeft",
  "icon-chevronRight": "ButtonCircle-module-scss-module__gpw-hW__icon-chevronRight",
  "icon-minus": "ButtonCircle-module-scss-module__gpw-hW__icon-minus",
  "icon-playVideo": "ButtonCircle-module-scss-module__gpw-hW__icon-playVideo",
  "icon-plus": "ButtonCircle-module-scss-module__gpw-hW__icon-plus",
  "large-thick-blue": "ButtonCircle-module-scss-module__gpw-hW__large-thick-blue",
  "large-thick-cream": "ButtonCircle-module-scss-module__gpw-hW__large-thick-cream",
  "root": "ButtonCircle-module-scss-module__gpw-hW__root",
  "small-fill-blue": "ButtonCircle-module-scss-module__gpw-hW__small-fill-blue",
  "small-fill-bluedark": "ButtonCircle-module-scss-module__gpw-hW__small-fill-bluedark",
  "small-fill-cream": "ButtonCircle-module-scss-module__gpw-hW__small-fill-cream",
  "small-fill-creamdark": "ButtonCircle-module-scss-module__gpw-hW__small-fill-creamdark",
  "small-fill-gold": "ButtonCircle-module-scss-module__gpw-hW__small-fill-gold",
  "small-fill-makers-brown": "ButtonCircle-module-scss-module__gpw-hW__small-fill-makers-brown",
  "small-fill-orange": "ButtonCircle-module-scss-module__gpw-hW__small-fill-orange",
  "small-fill-white": "ButtonCircle-module-scss-module__gpw-hW__small-fill-white",
});
